<template>
    <div class="absolute top-0 left-0 w-full h-full rounded-lg flex flex-col gap-y-4 overflow-hidden">
        <div class="relative w-full h-full flex flex-col border rounded-lg sm:p-2 p-5 gap-y-5">
            <div class="absolute top-0 left-0 w-full h-full flex flex-col gap-4 p-4">
                <h2 class="text-xl mb-4">{{ $t("packages.auto.nuestros_paquetes") }}</h2>

                <div class="w-full flex  items-center justify-between gap-y-5">
                    <button type="button"
                    class="bg-egreen-400 w-auto text-white px-4 py-1.5 rounded-lg text-md inline-flex justify-center items-center gap-2"
                    @click="showModal()">
                        <span >
                            <svg  
                            xmlns="http://www.w3.org/2000/svg"   
                            width="24" 
                            height="24"  
                            viewBox="0 0 24 24"  
                            fill="none"  
                            stroke="currentColor"  
                            stroke-width="2"  
                            stroke-linecap="round"  
                            stroke-linejoin="round" 
                            class="w-5 h-5 "><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" /><path d="M9 12h6" /><path d="M12 9v6" /></svg>
                        </span>
                        <span>{{ $t("packages.auto.agregar") }}</span>
                    </button>
                    
                    <input 
                    type="text" 
                    name="search"
                    v-model="search" 
                    class="rounded-lg border text-md sm:w-full md:w-80 focus:ring-blue-500 px-4 py-1.5"
                    @keyup="searchInput()"
                    :placeholder="$t('packages.auto.paquete')">
                </div>
                
                <div class="w-full max-h-full fle flex-grow items-start justify-start rounded-lg overflow-y-auto">
                    <PackageTable :packages="packageList" :set-package="setPackage"/>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import { initFlowbite } from 'flowbite';
    import PackageTable from './components/PackageTable.vue'
    import packageRequest from '@/services/admin/package-service.js'
    import PackageFormSidebar from './components/PackageFormSidebar.vue';
    import { useOverlay } from '@/services/overlay-service';
    import { createSidebarConfig } from '@/utils/overlay-utils';
    export default {
        name:'PackageIndex',
        data(){
            return {
                packages:[],
                packageList:[],
                packageSelected:null,
                search:"",
                currentOverlayId: null
            }
        },
        setup() {
            const overlayService = useOverlay();
            return { overlayService };
        },
        components:{
            PackageTable
        },
        methods:{
            showModal(){
                this.currentOverlayId = this.overlayService.open(
                    createSidebarConfig({
                        component: PackageFormSidebar,
                        props: {
                            selectedPackage: this.packageSelected,
                            loadData: this.initData,
                            overlayService: this.overlayService
                        },
                        onClose: () => {
                            this.packageSelected = null;
                            this.currentOverlayId = null;
                        }
                    })
                );
            },
            initData(){
                this.getPackages()
            },
            setPackage(packageSelected){
                this.packageSelected = packageSelected
                this.showModal()
            },
            getPackages(){
                packageRequest.getAllPackage()
                .then(
                    res=>{
                        if(res.status == 200){
                            let {data} = res
                            this.packages = data
                            this.packageList = [...data]
                        }
                    }
                )
                .catch(
                    error=>{
                        console.log(error)
                    }
                )
            },
            searchInput(){
                if(this.search){
                    this.packageList = this.packages.filter(item => item.name.toLowerCase().includes(this.search.toLowerCase()))
                }else{
                    this.packageList = this.packages
                }
            }
        },
        mounted(){
            initFlowbite()
            this.initData()
        
        }
    }
</script>

<style lang="scss" scoped>

</style>